export { createStyles } from '@mantine/core'
